import { lighten, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    color: theme.palette.common.black,
    display: 'grid',
    gridGap: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: {
      gridGap: theme.spacing(2),
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexWrap: 'nowrap',
    color: theme.palette.common.gray600,
    flex: 1,
  },
  innerText: {
    display: 'flex',
  },
  icons: {
    color: theme.palette.common.gray800,
    marginRight: theme.spacing(2),
  },
  colorGray: {
    color: theme.palette.common.gray600,
  },
  capsulesWrapper: {
    display: 'flex',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(2),
    },
  },
  capsule: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    background: lighten(theme.palette.primary.main, 0.9),
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1.25)}px`,
    borderRadius: '20px',
  },
  capsuleIcon: {
    height: '18px',
    width: '18px',
  },
  locationAndPay: {
    display: 'grid',
    alignItems: 'center',
    backgroundColor: theme.palette.common.gray100,
    borderRadius: 5,
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
}));
